import {PermissionCheck} from "../permission/PermissionCheck";
import {SubscriptionCheck} from "../subscription/SubscriptionCheck";
import { PermissionV2 } from '../permission/enum/PermissionV2';

function getRequiredLevel(item) {
    const {isDelete, isUpdate, isCreate, isView, requiredLevel} = item;

    if (requiredLevel)
        return requiredLevel;
    if (isDelete)
        return PermissionV2.delete;
    if (isUpdate)
        return PermissionV2.update;
    if (isCreate)
        return PermissionV2.create;
    if (isView)
        return PermissionV2.read;
    return null;
}

function checkPermission(item) {
    const {permission, url, transactionType} = item;

    if (permission)
        return PermissionCheck.withKeys(permission);
    if (transactionType)
        return PermissionCheck.withTransactionType(transactionType);
    if (url)
        return PermissionCheck.withUrl(url);
    return PermissionCheck.withCurrentRoute();
}

function checkSubscription(item) {
    const {subscription, url, transactionType} = item;

    if (subscription)
        return SubscriptionCheck.withKeys(subscription);
    if (transactionType)
        return SubscriptionCheck.withTransactionType(transactionType);
    if (url)
        return SubscriptionCheck.withUrl(url);
    return SubscriptionCheck.withCurrentRoute();
}

/** Helper Functions for:
 *  - PageHeaderExtra
 *  - ListMenu etc.
 *
 * This function adds permission/subscription-related props to items (of the above components)
 *
 * Section 1: Defining the Required Level
 *      - isDelete: when true => CRUD (highest priority)
 *      - isUpdate: when true => CRU_
 *      - isCreate: when true => CR__
 *      - isView:   when true => _R__ (lowest priority)
 *      (Obsolete: isAction)
 *
 * Section 2: Defining the Permission Key (which one to refer to)
 * - permission: PermissionKey or PermissionKey[]
 * - transactionType: TransactionType (optional)
 * - url: string
 * - <none> => Will take the current route's Permission Key
 *
 * Section 3: Defining the Permission Key (which one to refer to)
 * - subscription: SubscriptionKey or SubscriptionKey[]
 * - transactionType: TransactionType (optional)
 * - url: string
 * - <none> => Will take the current route's Permission Key
 *
 * ** NOTE: when none of the 4 props above are provided:
 *      - It will take the permission / subscription key of the current route.
 *
 * =========================
 * When used at PageHeaderExtra / ListMenu etc., this function will add:
 * - hidden: boolean
 * - locked: boolean
 * =========================
 **/
export function addAccessToItem(item) {
    // Determine required level
    const requiredLevel = getRequiredLevel(item);

    // If current item has any inhibitor modifier, will NOT ALLOW feature if permission has that modifier
    const {inhibitorModifiers} = item;

    // Check Permission / Subscription
    const hasPermission = checkPermission(item).hasPermissionTo(requiredLevel, inhibitorModifiers);
    const hasSubscription = checkSubscription(item).hasSubscriptionTo();

    return {
        ...item,
        isHidden: !hasPermission || item.isHidden,
        isLocked: !hasSubscription || item.overrideHasSubscription === false,
        submenu: item.submenu ? item.submenu.map(addAccessToItem).filter(item => !item.isHidden) : undefined,
    };
}

export function addAccessToItems(items) {
    return items.map(addAccessToItem)
        .filter(item => !item.isHidden)
        .filter(item => ((item.submenu) ? item.submenu.length > 0 : true));
}
